import { ArrowsClockwise } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";

import useTargetingMutations from "../../../../../datahooks/useTargetingMutations";
import SectionHeading from "../../../SectionHeading";
import Stepper from "../../Stepper";
import StepperNextButton from "../../StepperNextButton";
import GroupAndEventPreview from "./GroupAndEventPreview";
import GroupAndEventSelect from "./GroupAndEventSelect";

import type { LinkedInEvent, LinkedInGroup } from "../../../../../types";

const groupAndEventMeta: Record<
  "group" | "event",
  {
    label: string;
    description: string;
  }
> = {
  group: {
    label: "Group",
    description:
      "LinkedIn group campaigns work by engaging other users that are part of the same group as you. Choose the group you want to target below and start building your campaign",
  },
  event: {
    label: "Event",
    description:
      "LinkedIn event campaigns work by engaging other users that are attending the same event. Choose the event you want to target below and start building your campaign",
  },
};

export default function GroupAndEvent({
  type,
  initialId,
}: {
  type: "group" | "event";
  initialId: string | undefined;
}) {
  const [selectedGroupOrEvent, setSelectedGroupOrEvent] = useState<
    LinkedInGroup | LinkedInEvent
  >(null);
  const { setTargeting, isSettingTargeting } = useTargetingMutations();

  function goToNextStep() {
    const campaignTargeting =
      type === "group"
        ? { group_id: selectedGroupOrEvent.id }
        : { event_id: selectedGroupOrEvent.id };

    setTargeting({ campaignTargeting });
  }

  const { label, description } = groupAndEventMeta[type];

  return (
    <>
      <SectionHeading title={`${label} search`} subtitle={description} />

      <section className="mx-auto flex w-full max-w-[888px] flex-col mt-4">
        {selectedGroupOrEvent ? (
          <>
            <GroupAndEventPreview groupOrEvent={selectedGroupOrEvent} />
            <Button
              variant="secondary-black"
              leftIcon={<ArrowsClockwise />}
              className="ml-auto mt-4"
              onClick={() => setSelectedGroupOrEvent(null)}
            >
              Change {type}
            </Button>
          </>
        ) : (
          <GroupAndEventSelect
            initialId={initialId}
            type={type}
            selectGroupOrEvent={(groupOrEvent) =>
              setSelectedGroupOrEvent(groupOrEvent)
            }
          />
        )}
      </section>

      <Stepper
        selectedIndex={0}
        nextButtonComponent={
          <StepperNextButton
            onClick={goToNextStep}
            isLoading={isSettingTargeting}
            disabled={!selectedGroupOrEvent}
          />
        }
      />
    </>
  );
}
